(()=>{'use strict';
if(window.__qmerSearchTitleNormalizer)return;
window.__qmerSearchTitleNormalizer=true;
const titles={
  '/pages/qst':'QST Listing Workspace',
  '/pages/sync-tool':'QST Listing Workspace',
  '/pages/free-tools':'Free Seller Tools',
  '/pages/qst-founder-story':'QST Founder Story',
  '/pages/games':'Q-MER.CH Arcade',
  '/pages/pulse-rift':'Pulse Rift',
  '/pages/game-galactic-defender':'Galactic Defender',
  '/pages/game-space-raiders':'Space Raiders',
  '/pages/game-tetris':'Prism Drop',
  '/pages/game-pacman':'Neon Maze',
  '/pages/game-space-shooter-time-attack':'Star Rush',
  '/pages/game-block-buster':'Block Buster',
  '/pages/game-stack-master':'Stack Master',
  '/pages/game-domino-match':'Domino Match',
  '/pages/game-t-game':'Reactor Rally',
  '/pages/sound-lab':'Q-MER.CH Sound Lab'
};
let queued=false;
function normalise(){
  queued=false;
  document.querySelectorAll('#predictive-search-results a[href], .template-search__results a[href]').forEach((anchor)=>{
    let path;
    try{path=new URL(anchor.getAttribute('href'),location.origin).pathname.replace(/\/$/,'')||'/';}catch(_error){return;}
    const title=titles[path];
    if(!title)return;
    let target=anchor.querySelector('.predictive-search__item-heading');
    if(!target&&anchor.classList.contains('full-unstyled-link'))target=anchor;
    if(!target||target.textContent.trim()===title)return;
    target.textContent=title;
  });
}
function queueNormalise(){
  if(queued)return;
  queued=true;
  requestAnimationFrame(normalise);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',normalise,{once:true});else normalise();
const root=document.body||document.documentElement;
new MutationObserver(queueNormalise).observe(root,{childList:true,subtree:true});
})();
